import { getVueComponent, hasVueComponent } from '../vvuejs/vueRegister.mjs'
import { asyncAngularInvoke } from '/vodalys/vvuejs'

import './vnotification.notificationDeclaration.mjs'

import { debug } from '/vodalys/.jslibs/'
const log = debug('vnotification:service')
const logNotif = debug('vnotification:service:notif')


function checkComponentVueImplementation(component) {
    let type = component['#type']

    if (typeof type == 'string') {
        type = [type]
    }

    if (!type.some(ty => hasVueComponent(ty))) {
        return false
    }

    return true
}
function getComponentVueImplementation(component) {
    let type = component['#type']

    if (typeof type == 'string') {
        type = [type]
    }

    return getVueComponent(type.find(ty => hasVueComponent(ty)))

}


export default new class NotificationService {

    constructor() {

        this._toasts = []
        this._progressItems = []
        this._bigStickies = []

        asyncAngularInvoke((vnotification_service) => {

            Object.assign(this, {
                vnotification_service
            })

            vnotification_service._toasts = this._toasts
            vnotification_service._progressItems = this._progressItems

            const oldAdd = vnotification_service.add
            vnotification_service.add = (key, notif) => {
                // Check if this specifique notification has a vuejs translation (and is child component too)
                if (!checkComponentVueImplementation(notif)) {
                    logNotif('ng notif', notif)
                    return oldAdd(key, notif)
                }

                if (notif.progressingNotification) {
                    logNotif('vue progressingNotification', notif)
                    this.progressItem(key, notif)
                }
                else if (notif.bigSticky) {
                    logNotif('vue bigSticky', notif)
                    this.bigSticky(key, notif)
                }
                else {
                    logNotif('vue toast', notif)
                    this.toast(key, notif)
                }
            }

            const oldRemove = vnotification_service.remove
            vnotification_service.remove = key => {

                this.toastRemove(key)
                return oldRemove(key)
            }

            log('initialized...')
        })
    }

    /**
     * 
     * @param {*} toastObj 
     */
    toast(_key, component, collection = this._toasts) {

        const remove = () => {
            this.toastRemove(_key, collection)
        }

        let timeout
        if (component.delay && component.delay != Number.POSITIVE_INFINITY) {
            timeout = setTimeout(_ => {
                remove()
            }, component.delay)
        }

        collection.push(
            {
                _key,
                component,
                timeout,
                remove
            })
    }

    toastRemove(_key, collection = this._toasts) {
        const i = collection.findIndex(t => t._key === _key)
        const toast = collection[i];
        if (i === -1) {
            return
        }
        collection.splice(i, 1)
        clearTimeout(toast && toast.timeout) // juste in case
    }

    bigSticky(_key, component) {
        return this.toast(_key, component, this._bigStickies)
    }
    bigStickyRemove(_key) {
        return this.toastRemove(_key, this._bigStickies)
    }


    progressItem(_key, component) {


        console.warn('progressItem')

        const remove = () => {
            this.progressItemRemove(_key)
        }

        const vueComponent = getComponentVueImplementation(component)

        this._progressItems.push(
            {
                _key,
                component,
                vueComponent,
                // timeout,
                remove
            })
    }


    progressItemRemove(_key) {
        const i = this._progressItems.findIndex(t => t._key === _key)
        const toast = this._progressItems[i];
        if (i === -1) {
            return
        }
        this._progressItems.splice(i, 1)
    }

}

